var map = {
	"./Group 22302.png": 1313,
	"./avatar-christmas.webp": 1314,
	"./bottom-bg-christmas.webp": 1315,
	"./btn-active.png": 1316,
	"./content-deco-1.webp": 1317,
	"./content-deco-2.webp": 1318,
	"./content-deco-3.webp": 1319,
	"./content-deco-4.webp": 1320,
	"./deco-3.webp": 1321,
	"./deposit-icon.webp": 1322,
	"./home-icon-active.webp": 1323,
	"./home-icon.webp": 1324,
	"./live-icon-active.webp": 1325,
	"./live-icon.webp": 1326,
	"./master-bg.jpg": 1327,
	"./me-icon-active.webp": 1328,
	"./me-icon.webp": 1329,
	"./platform.png": 1330,
	"./platform.webp": 1331,
	"./promos-icon-active.webp": 1332,
	"./promos-icon.webp": 1333,
	"./promos.webp": 1334,
	"./service-christmas.webp": 1335,
	"./snowman.webp": 1336,
	"./sponsor-icon-active.webp": 1337,
	"./sponsor-icon.webp": 1338,
	"./title-deco-left.webp": 1339,
	"./title-deco-right.webp": 1340,
	"./tree.webp": 1341,
	"./vip-icon.webp": 1342,
	"./vip.webp": 1343,
	"./withdraw-icon.webp": 1344,
	"./wwr-img.webp": 1345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;